<div sbbDialogContent [class]="getContentClassTag()">
  <sbb-form-field
    class="sbb-form-field-long"
    [label]="'app.view.dialogs.trainrun-and-section-dialog.trainrun-filter-tab.labels' | translate"
  >
    <sbb-chip-list [value]="trainrunLabels" (focusout)="onLabelsFocusout()">
      <sbb-chip *ngFor="let element of trainrunLabels" [value]="element" (removed)="remove($event)">
        {{ element }}
      </sbb-chip>
      <input
        id="trainrunLabelsInput"
        [placeholder]="
          'app.view.dialogs.trainrun-and-section-dialog.trainrun-filter-tab.newLabels' | translate
        "
        sbbChipInput
        cdkFocusInitial
        [sbbChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (sbbChipInputTokenEnd)="add($event)"
        [sbbAutocomplete]="trainrunLabelsAutoComplete"
      />
    </sbb-chip-list>
    <sbb-autocomplete #trainrunLabelsAutoComplete="sbbAutocomplete">
      <sbb-option *ngFor="let option of trainrunLabelsAutoCompleteOptions" [value]="option">{{
        option
      }}</sbb-option>
    </sbb-autocomplete>
  </sbb-form-field>
</div>
<div sbbDialogActions [class]="getContentFooterClassTag()">
  <button
    class="FunctionButton"
    tabindex="-1"
    (click)="onDuplicateTrainrun()"
    [title]="
      'app.view.dialogs.trainrun-and-section-dialog.trainrun-tab.trainrunDuplicate' | translate
    "
  >
    <sbb-icon svgIcon="plus-medium" aria-hidden="false"></sbb-icon>
  </button>
  <button
    class="FunctionButton"
    tabindex="-1"
    (click)="onDeleteTrainrun()"
    [title]="'app.view.dialogs.trainrun-and-section-dialog.trainrun-tab.trainrunDelete' | translate"
  >
    <sbb-icon svgIcon="trash-medium" aria-hidden="false"></sbb-icon>
  </button>
</div>
